import { PlanningFilterSetting } from '@digiwall/goliath-documents/proxy';

/**
 * The opaque per-data-source filter dictionary as carried on the config DTOs: filter key → setting.
 * The generic layer never interprets the keys; each data source's own components/backend do.
 */
export type FilterSettingsMap = Record<string, PlanningFilterSetting>;

/** An empty settings map (stable reference for defaults). */
export const EMPTY_FILTER_SETTINGS: FilterSettingsMap = {};

/**
 * Serializable snapshot of a board filter's current user input, for persisting/restoring a data
 * source's active filters. The keys are the data source's own filter keys (never interpreted here).
 */
export interface PlanningBoardFilterState {
  /** Selected option ids per dropdown (multi-select) filter key. */
  selection?: Record<string, string[]>;
  /** Entered substring per free-text filter key. */
  text?: Record<string, string>;
}

/** Number of filters that are enabled in a settings map (used for the config aside button counter). */
export function countEnabledFilters(settings: FilterSettingsMap | undefined): number {
  return Object.values(settings ?? {}).filter(setting => setting.enabled).length;
}
